<template>
    <div class="site__body">
        <div class="block-header block-header--has-breadcrumb block-header--has-title">
            <div class="container">
                <div class="block-header__body">
                    <div class="flexbox-page-info-container">
                        <div class="flex-item-page-info-breadcrumbs">
                            <nav class="breadcrumb block-header__breadcrumb" aria-label="breadcrumb">
                                <ol class="breadcrumb__list">
                                    <li class="breadcrumb__spaceship-safe-area" role="presentation"></li>
                                    <li class="breadcrumb__item breadcrumb__item--parent breadcrumb__item--first">
                                            
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <!-- <a href="" class="breadcrumb__item-link">Engine Kits</a> -->
                                        <router-link to="/category" class="breadcrumb__item-link">Category</router-link>
                                    </li>
                                    <li class="breadcrumb__item breadcrumb__item--parent">
                                        <router-link to="/kit-catalog" class="breadcrumb__item-link">Engine Kits</router-link>
                                    </li>
                                    <li class="breadcrumb__title-safe-area" role="presentation"></li>
                                </ol>
                            </nav>
                        </div>

                        <div class="flex-item-page-info-title">
                            <h1 class="block-header__breadcrumb-slim">Kit Catalog Search</h1>
                        </div>
                    </div>
                    <div class="flex-item-page-info-selected-vehicle-kits">
                        <div class="flex-container--breadcrumbs-selected-vehicle">
                            <div class="flex-container--select-vehicle-column">
                                <div class="vehicles-list__item-name">Please select an engine to search our kits.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="block-space--layout--divider-20"></div>
        <div class="block-split">
            <div class="container">
                <div class="block-split__row row no-gutters">
                    <div class="block-split__item block-split__item-sidebar col-auto">
                        <div class="sidebar sidebar--offcanvas--mobile">
                            <div class="sidebar__backdrop"></div>
                            <div class="sidebar__body">
                                <div class="sidebar__header">
                                    <div class="sidebar__title">Filters</div>
                                    <button class="sidebar__close" type="button">
                                        <svg width="12" height="12">
                                            <path
                                                d="M10.8,10.8L10.8,10.8c-0.4,0.4-1,0.4-1.4,0L6,7.4l-3.4,3.4c-0.4,0.4-1,0.4-1.4,0l0,0c-0.4-0.4-0.4-1,0-1.4L4.6,6L1.2,2.6
c-0.4-0.4-0.4-1,0-1.4l0,0c0.4-0.4,1-0.4,1.4,0L6,4.6l3.4-3.4c0.4-0.4,1-0.4,1.4,0l0,0c0.4,0.4,0.4,1,0,1.4L7.4,6l3.4,3.4
C11.2,9.8,11.2,10.4,10.8,10.8z"
                                            />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="center">
                        <div class="block-split__item block-split__item-content col-auto">
                            <div class="block">
                                <div class="modal-content">
                                    <div class="vehicle-picker-modal__panel vehicle-picker-modal__panel--active" data-panel="form">
                                        <div class="vehicle-picker-modal__title card-title">Select Engine</div>
                                        <div class="vehicle-form vehicle-form--layout--modal">
                                            <div class="vehicle-form__item vehicle-form__item--select">
                                                <select class="form-control" aria-label="Year" @change="getKitMakes" v-model="lsel_year">
                                                    <option value="" selected>Select</option>
                                                    <option :value="yr.DMCD02" v-for="(yr, index) in lyears" :key="index">
                                                        {{yr.categoryname}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="vehicle-form__item vehicle-form__item--select">
                                                <select class="form-control" aria-label="Make" :disabled="(lmakes.length == 0)" v-model="lsel_make" @change="getKitEngines">
                                                    <option value="" selected>Select</option>
                                                    <option :value="mk.DMCD03" v-for="(mk, index) in lmakes" :key="index">
                                                        {{mk.categoryname}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="vehicle-form__item vehicle-form__item--select">
                                                <select class="form-control" aria-label="Engine" v-model="lsel_eng" :disabled="(lengines.length == 0)" @change="getKitVIN">
                                                    <option value="" selected>Select</option>
                                                    <option :value="eng.DMCD04" v-for="(eng, index) in lengines" :key="index">
                                                        {{eng.categoryname}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="vehicle-form__item vehicle-form__item--select">
                                                <select class="form-control" aria-label="VIN Code" :disabled="(lvins.length == 0)"  v-model="lsel_vin" @change="vinDesc">
                                                    <option value="" selected>Select</option>
                                                    <option :value="vin.DMCD05" v-for="(vin, index) in lvins" :key="index">
                                                        {{vin.categoryname}}
                                                    </option>
                                                </select>
                                            </div>
                                            <div class="vehicle-form__divider">Or</div>
                                            <div class="vehicle-form__item ">
                                                <select class="form-control " aria-label="Previously Selected Engines" v-model="lsel_saved" @change="goToResults($event.target.value)">
                                                    <option value="none">Previously Selected Engines</option>
                                                    <option v-for="(option, index) in savedEngines" :svalue="option.LASTTEXT" :key="index">
                                                        {{option.LASTTEXT}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="vehicle-picker-modal__actions">
                                            <button class="btn btn-primary btn-sm" @click="goToKit" :disabled="allowSearch">Search Kits</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="block-space block-space--layout--before-footer"></div>
            </div>
        </div>
    </div>
</template>

<script>
import axiosvl from "../../../axios/axios-vl.js";

export default {

    data () {
        return {
            // selected fields
            lsel_year: '',
            lsel_make: '',
            lsel_eng: '',
            lsel_vin: '',
            lsel_saved: '',
            lsel_option: {},

            year_desc: '',
            make_desc: '',
            eng_desc: '',
            vin_desc: '',

            engine_kit: [],
            lyears : [],
            lmakes : [],
            lengines : [],
            lvins : [],

            savedEngines: [],
        }
    },

    computed: {
        allowSearch(){
            if((this.lsel_year == '' || this.lsel_make == '' || this.lsel_eng == '' || this.lsel_vin == '') && this.lsel_saved == '' )
                return true;
            return false;
        }
    },

    methods: {
        getKitMakes() {
            this.lmakes = [];
            if(this.lsel_year != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lmakes.findIndex(y => {y.DMCD03 == eng.DMCD03});
                    if(i <= -1 && eng.DMCD02 == this.lsel_year && eng.categorylevel == 3){
                        this.lmakes.push(eng);
                    }
                });

                this.lmakes.sort((a,b) => (a.DMCD03 > b.DMCD03) ? 1 : ((b.DMCD03 > a.DMCD03) ? -1 : 0));
            }else{
                this.lengines = [];
                this.lvins = [];
                this.lsel_make = '';
                this.lsel_eng = '';
                this.lsel_vin = '';
            }
        },

        getKitEngines() {
            this.lengines = [];

            if(this.lsel_make != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lengines.findIndex(y => {y.DMCD04 == eng.DMCD04});
                    if(i <= -1 && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 4){
                        this.lengines.push(eng);
                    }
                });

                this.lengines.sort((a,b) => (a.DMCD04 > b.DMCD04) ? 1 : ((b.DMCD04 > a.DMCD04) ? -1 : 0));
            }else{
                this.lvins = [];
                this.lsel_eng = '';
                this.lsel_vin = '';
            }
        },  

        getKitVIN() {
            this.lvins = [];
            if(this.lsel_eng != ''){
                this.engine_kit.forEach(eng => {
                    var i = this.lvins.findIndex(y => {y.DMCD05 == eng.DMCD05});
                    if(i <= -1 && eng.DMCD04 == this.lsel_eng && eng.DMCD02 == this.lsel_year && eng.DMCD03 == this.lsel_make && eng.categorylevel == 5){
                        this.lvins.push(eng);
                    }
                });

                this.lvins.sort((a,b) => (a.DMCD05 > b.DMCD05) ? 1 : ((b.DMCD05 > a.DMCD05) ? -1 : 0));
            }else{
                this.lsel_vin = '';
            }
        },

        vinDesc(){
            const sel_kvin = this.lvins.find(e => e.DMCD05 == this.lsel_vin);
            this.vin_desc = sel_kvin.categoryname;
        },

        goToKit() {

            if(this.lsel_saved != '') {
                const payload = this.$store.getters['vehicle/kit_vehicle'];
                payload.year = this.lsel_option.DMCD02;
                payload.make = this.lsel_option.DMCD03;
                payload.engine = this.lsel_option.DMCD04;
                payload.vin = this.lsel_option.DMCD05;

                this.$store.dispatch("vehicle/setKit_vehicle", payload);

                this.$router.push('/sub-category/5/' + this.lsel_option.DMCD01 + '/' + this.lsel_option.DMCD02 + '/' + this.lsel_option.DMCD03 + '/' + this.lsel_option.DMCD04 + '/' + this.lsel_option.DMCD05);
            }else{

                const payload = this.$store.getters['vehicle/kit_vehicle'];
                payload.year = this.lsel_year;
                payload.make = this.lsel_make;
                payload.engine = this.lsel_eng;
                payload.vin = this.lsel_vin;

                this.$store.dispatch("vehicle/setKit_vehicle", payload);
                
                this.$router.push('/sub-category/5/ENGKT/' + this.lsel_year + '/' + this.lsel_make + '/' + this.lsel_eng + '/' + this.lsel_vin);
            }
            
        },

        lastCategories() {
            const last_cat_uri = this.$store.getters['api/last_category_uri'];
            axiosvl.post(last_cat_uri, {
                "webroutine": {
                    "context": {
                        "session-key-method": "hidden"
                    },
                    "fields": {
                        "EHCUST": { "value": this.$store.getters.customer },
                    },   
                }
            })
            .then((response) => {
                const CATLAST = response.data.webroutine.lists.CATLAST.entries;
                // console.log(response);

                CATLAST.forEach(cat => {
                    if(cat.DMCD01 != 'ENGKT'){
                        return false;
                    }

                    if(cat.DMCD02 == '' || cat.DMCD03 == '' || cat.DMCD04 == '' || cat.DMCD05 == ''){
                        return false;
                    }

                    this.savedEngines.push(cat);
                });

                // console.table(this.savedEngines);
            })
        },

        goToResults(val) {
            this.lsel_option = this.savedEngines.find(e => {
                // console.log(e.LASTTEXT.trim());
                return e.LASTTEXT.trim() == val;
            });

            this.lsel_year = this.lsel_option.DMCD02;
            this.getKitMakes();
            this.lsel_make = this.lsel_option.DMCD03;
            this.getKitEngines();          
            this.lsel_eng = this.lsel_option.DMCD04;
            this.getKitVIN();
            this.lsel_vin = this.lsel_option.DMCD05;
        }
    },

    created() {
        this.$ga.page({
            page: this.$route.fullPath,
            title: this.$route.name,
        });
        let categories = this.$store.getters['product/categories'];
        // console.table(this.$store.getters['vehicle/kit_vehicle']);

        this.engine_kit = categories.filter(c => c.DMCD01 == 'ENGKT');
        // console.table(this.engine_kit);

        this.lyears = [];
        
        this.engine_kit.forEach(eng => {
            var i = this.lyears.findIndex(y => {y.DMCD02 == eng.DMCD02 });
            if(i <= -1 && eng.DMCD02 != '' && eng.categorylevel == 2){
                this.lyears.push(eng);
            }
        });

        this.lyears.sort((a,b) => (a.DMCD02 < b.DMCD02) ? 1 : ((b.DMCD02 < a.DMCD02) ? -1 : 0));

        this.lastCategories();

        // console.log(this.lyears);
    }
    
}
</script>